export default __webpack_public_path__ + "static/media/glacier.c231e4d8.png";